module.exports = __webpack_public_path__ + "img/Frame_2.3d08f011.png";